import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export function useData(path, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(path);
      setData(res.data);
    } catch (e) {
      if (e.response?.status !== 401) toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, deps);
  return { data, loading, reload, setData };
}

export async function save(method, path, body) {
  try {
    const res = await api[method](path, body);
    return res.data;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Operation failed");
    throw e;
  }
}
